import React, { Component } from 'react';
import {
  Icon,
  Modal,
  Header,
} from 'semantic-ui-react';
import cx from 'classnames';
import FileSaver from 'file-saver';
import api from '../../api';
import {
  REPORT_EXTENSION_CSV,
  REPORT_EXTENSION_EXCEL,
  REPORT_EXTENSION_JSON,
} from '../../constants/reports';
//import { convertPropertiesToCamelCase } from '../../utils/shared';
import deleteIcon from '../../images/components/content_project_card/delete-icon.svg';
import exportIcon from '../../images/components/content_project_card/export-icon.svg';
import compareBtn from '../../images/icons/compare.png';
import moveFileIcon from '../../images/components/content_project_card/move-file-icon.svg';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';
import ScanInfoModal from '../Modal/ScanInfoModal';
import LeakageListModal from '../Modal/LeakageListModal';
import DeleteModal from '../Modal/DeleteModal';
import ExportModal from '../Modal/ExportModal';
import MoveFileModal from '../Modal/MoveFileModal';
import SPDXDocumentGenerator from '../SBOM/SPDXDocumentGenerator';
import SecurityRiskUpdatedModal from '../Modal/SecurityRiskUpdatedModal';
import CycloneDXDocumentGenerator from '../SBOM/CycloneDXDocumentGenerator';
import VexGenerator from '../SBOM/VexGenerator';
import CBOMGenerator from '../SBOM/CBOMGenerator';
import ScanResultModal from '../Modal/ScanResultModal';
import CreateUserIssueModal from '../Jira/CreateUserIssueModal';
import NISModal from '../NISTools/NISModal';

class MoreOptionsMenu extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    this.state = {
      isOpen: false,
      isOpenMSU: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMCI: false,
      isOpenMNA: false,
      isOpenMVX: false,
      isOpenMSR: false,
      isOpenMFM: false,
      isOpenMSI: false,
      isOpenMLK: false,
      modalExportIsOpen: false,
      isDownloadingReport: false,
      isMovingFile: false,
      isOpenAlertModal: false,
      isShowSbom: false,
      isOpenMCB: false,
      toExport: '',
      scanInfoUid: '',
      selectedName: '',
      selectedUid: '',
    };
    this.closeModal = this.closeModal.bind(this);
    this.deletedCallback = this.deletedCallback.bind(this);
    this.handleSecurityInfoItem = this.handleSecurityInfoItem.bind(this);
    this.handleInfoItem = this.handleInfoItem.bind(this);
    this.handleLeakageList = this.handleLeakageList.bind(this);
    this.handleCardBookmarkChange = this.handleCardBookmarkChange.bind(this);
    this.handleSlideToggle = this.handleSlideToggle.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleSpdx = this.handleSpdx.bind(this);
    this.handleCycloneDx = this.handleCycloneDx.bind(this);
    this.handleVexBom = this.handleVexBom.bind(this);
    this.handleNIASbom = this.handleNIASbom.bind(this);
    this.handleAddScanResults = this.handleAddScanResults.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleIssueCallback = this.handleIssueCallback.bind(this);
    this.handleSaveCallback = this.handleSaveCallback.bind(this);
    this.handleMCIOpen = this.handleMCIOpen.bind(this);
    this.rescanReport = this.rescanReport.bind(this);
    this.refreshSecurityReport = this.refreshSecurityReport.bind(this);
    this.setCompareItem = this.setCompareItem.bind(this);
    this.setFileMove = this.setFileMove.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.handleCBOM = this.handleCBOM.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleSecurityInfoItem = () => {
    const { closeMenu } = this.props;
    this.setState({
      isOpenMSU: true,
    });
    closeMenu();
  };

  handleSlideToggle = () => {
    const { isShowSbom } = this.state;
    this.setState({
      isShowSbom: !isShowSbom,
    });
  };

  handleExport = () => {
    const { closeMenu } = this.props;
    this.setState({
      modalExportIsOpen: true,
      isShowSbom: false,
    });
    closeMenu();
  };

  handleSpdx = () => {
    const { closeMenu } = this.props;
    this.setState({
      isOpenMCX: true,
      isShowSbom: false,
    });
    closeMenu();
  };

  handleCycloneDx = () => {
    const { closeMenu } = this.props;
    this.setState({
      isOpenMCD: true,
      isShowSbom: false,
    });
    closeMenu();
  };

  handleVexBom = () => {
    const { closeMenu } = this.props;
    this.setState({
      isOpenMVX: true,
      isShowSbom: false,
    });
    closeMenu();
  };

  handleNIASbom = () => {
    const { closeMenu } = this.props;
    this.setState({
      isOpenMNA: true,
      isShowSbom: false,
    });
    closeMenu();
  };

  handleAddScanResults = () => {
    const { closeMenu } = this.props;
    this.setState({
      isOpenMSR: true,
    });
    closeMenu();
  };

  handleDelete = () => {
    const { closeMenu } = this.props;
    this.setState({
      isOpen: true,
    });
    closeMenu();
  };

  handleMove = () => {
    const { closeMenu } = this.props;
    this.setState({
      isOpenMFM: true,
    });
    closeMenu();
  };

  handleMCIOpen() {
    const { closeMenu } = this.props;
    this.setState({
      isOpenMCI: true,
    });
    closeMenu();
  }

  handleCBOM() {
    const { closeMenu, rowData, translate } = this.props;
    const { hasCrypto } = rowData;

    if (hasCrypto) {
      this.setState({
        isOpenMCB: true,
      });
      closeMenu();
    } else {
      this.modalAction = translate('modal.title.notice');
      this.modalBody = translate('modal.message.no_crypto_data');
      this.modalHeader = null;

      this.setState({
        isOpenAlertModal: true,
      });
    }
  }

  handleIssueCallback() {
    const { handleIssueCallback, rowData } = this.props;
    handleIssueCallback(rowData.uid);
  }

  handleSaveCallback = () => {
    const { handleSaveCallback } = this.props;
    handleSaveCallback();
  };

  handleInfoItem = () => {
    const { rowData } = this.props;
    const { uid } = rowData;
    this.setState({
      scanInfoUid: uid,
      isOpenMSI: true,
    });
  };

  handleLeakageList = () => {
    const { rowData } = this.props;
    const { uid, name } = rowData;
    this.setState({
      selectedUid: uid,
      selectedName: name,
      isOpenMLK: true,
    });
  };

  handleCardBookmarkChange = (e, ufid) => {
    const { handleCardBookmarkChange } = this.props;
    api.toggleBookmark(
      {
        uploaded_file_id: ufid,
        view_point: 'overview',
      }
    )
      .then((response) => {
        const res = response.response;
        handleCardBookmarkChange(ufid, res.is_bookmark);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  setCompareItem() {
    const { setCompareItem, rowData } = this.props;
    setCompareItem(rowData);
  }

  setFileMove(obj, id) {
    const { updateFilePath } = this.props;
    this.setState({
      isMovingFile: true,
    }, () => {
      api.setFileMove({
        selected_project_id: obj.selectedProject.id,
        selected_project_version_id: obj.selectedProjectVersion.id,
      }, id)
        .then(() => {
          this.setState({
            isMovingFile: false,
            isOpenMFM: false,
          }, () => {
            updateFilePath(obj, id);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  generateToken = (length) => {
    let i = 0;
    let result = '';
    const timeStamp = new Date();
    const components = [
      timeStamp.getYear(),
      timeStamp.getMonth(),
      timeStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds(),
      timeStamp.getMilliseconds(),
    ];
    const id = components.join('');
    const charactersLength = id.length;

    for (i; i < length; i++) {
      result += id.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  closeModal() {
    this.setState({
      isOpen: false,
      isOpenMSU: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMCI: false,
      isOpenMNA: false,
      isOpenMVX: false,
      isOpenMSR: false,
      isOpenMFM: false,
      isOpenMSI: false,
      isOpenMLK: false,
      modalExportIsOpen: false,
      isOpenAlertModal: false,
      isOpenMCB: false,
    });
  }

  deletedCallback() {
    const { rowData, deletedCallback } = this.props;
    deletedCallback(rowData.uid);
  }

  rescanReport() {
    const { rescanReport, rowData } = this.props;
    rescanReport(rowData.uid);
  }

  refreshSecurityReport() {
    const { refreshSecurityReport, rowData } = this.props;
    refreshSecurityReport(rowData.uid);
  }

  downloadReport(exportFormat, exportType, toExport) {
    const { translate, state, rowData } = this.props;
    const { currentPrecisionLevel } = state.user;
    const token = this.generateToken(10);
    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };
    let type;
    let url;

    if (currentPrecisionLevel) {
      type = currentPrecisionLevel;
    } else {
      type = null;
    }

    if (type) {
      url = `/1/reports/${
        rowData.uid
      }/export?file_format=${exportFormat}&section=${exportType}&token=${token}&precision_level=${type}&export_to=${toExport}`;
    } else {
      url = `/1/reports/${
        rowData.uid
      }/export?file_format=${exportFormat}&section=${exportType}&token=${token}&export_to=${toExport}`;
    }

    this.setState({
      isDownloadingReport: true,
    });

    api
      .getExportedReport(url)
      .then((res) => {
        let data;
        let confidenceLevelName;
        const blob = new Blob([res], { type: 'application/octet-stream' });
        if (rowData.precisionLevel === 'narrow') {
          confidenceLevelName = 'high';
        } else if (rowData.precisionLevel === 'broad') {
          confidenceLevelName = 'low';
        } else {
          confidenceLevelName = rowData.precisionLevel;
        }

        const fileName = `${rowData.name}_${confidenceLevelName}.${downloadFormatMapping[exportFormat]}`;

        this.modalAction = translate('modal.title.notice');

        if (toExport === 's3') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { bucket, key } = data.response;
          this.modalBody = translate('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{translate('modal.title.bucket')}</b>
              &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{translate('modal.title.file_storage_path')}</b>
              &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { dest_email } = data.response;
          this.modalBody = translate('modal.message.export_send_email');
          this.modalHeader = translate('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = translate('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }
        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch((err) => {
        console.log(err);
        let jsonParse;
        const ArrayBufferView = Object.getPrototypeOf(Object.getPrototypeOf(new Uint8Array())).constructor;
        if (err.data instanceof ArrayBuffer || err.data instanceof ArrayBufferView) {
          jsonParse = JSON.parse(new TextDecoder().decode(err.data));
        } else {
          jsonParse = err.data;
        }
        const o = jsonParse.response;
        this.modalAction = translate('modal.title.attention');

        if (!o.error) {
          this.modalBody = translate('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = translate('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = translate('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = translate('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = translate('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
        });

      });
  }

  renderMoveMenu() {
    const { translate, rowData } = this.props;
    const { scanStatus, hasPermission } = rowData;

    if (scanStatus !== 2) {
      return (
        <a
          style={{
            cursor: 'default',
            opacity: '.45',
            color: '#dddddd',
          }}
        >
          <img src={moveFileIcon} alt="" />
          {translate('card.menu.move')}
        </a>
      );
    }
    if (!hasPermission) {
      return (
        <a
          style={{
            cursor: 'default',
            opacity: '.45',
            color: '#dddddd',
          }}
        >
          <img src={moveFileIcon} alt="" />
          {translate('card.menu.move')}
        </a>
      );
    }
    return (
      <a
        onClick={this.handleMove}
        onKeyUp={this.handleMove}
      >
        <img src={moveFileIcon} alt="" />
        {translate('card.menu.move')}
      </a>
    );
  }

  renderJiraIssueEle(jira_issue) {
    const { translate, rowData } = this.props;
    const { scanStatus } = rowData;
    const data = jira_issue;

    if (scanStatus !== 2) {
      return (
        <a
          style={{
            cursor: 'default',
            opacity: '.45',
            color: '#dddddd',
          }}
        >
          <img className="icon-jira" src={JiraLogo} alt="" />
          {translate('settings.list.create_issue_card')}
        </a>
      );
    }

    if (data.url === '') {
      return (
        <a
          onClick={this.handleMCIOpen}
          onKeyUp={this.handleMCIOpen}
        >
          <img className="icon-jira" src={JiraLogo} alt="" />
          {translate('settings.list.create_issue_card')}
        </a>
      );
    }
    return (
      <span className="jira_issue">
        <a
          href={data.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline' }}
          className="jira_issue"
        >
          <img className="icon-jira" src={JiraLogo} alt="" />
          {data.key}
        </a>
      </span>
    );
  }

  render() {
    const {
      translate,
      rowData,
      menuRef,
      location,
      state,
    } = this.props;

    const {
      componentCountBroad,
      scanStatus,
      isScanning,
      hasLeakage,
      jiraIssue,
      isRescanned,
      uid,
      isBookmark,
      hasPermission,
    } = rowData;

    const {
      isOpen,
      isOpenMSU,
      isOpenMCX,
      isOpenMCD,
      isOpenMCI,
      isOpenMNA,
      isOpenMVX,
      isOpenMSR,
      isOpenMFM,
      isOpenMSI,
      isOpenMLK,
      isOpenMCB,
      modalExportIsOpen,
      isDownloadingReport,
      isMovingFile,
      isOpenAlertModal,
      toExport,
      scanInfoUid,
      selectedName,
      selectedUid,
      isShowSbom
    } = this.state;

    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    return (
      <div className="more_menu" ref={menuRef}>
        {isRescanned ? (
          <p className="noti">
            <a
              onClick={this.handleSecurityInfoItem}
              onKeyUp={this.handleSecurityInfoItem}
            >
              <Icon name="info circle" />
              {translate('card.menu.security_risk_updated')}
            </a>
          </p>
        ) : null}
        <ul>
          {
            (scanStatus === 2 || scanStatus === 3)
            && (
              <li>
                <a
                  onClick={this.handleInfoItem}
                  onKeyUp={this.handleInfoItem}
                >
                  <Icon name="info" style={{ color: '#969696' }} />
                  {translate('card.menu.information')}
                </a>
              </li>
            )
          }
          {
            hasLeakage ? (
              <li>
                <a
                  onClick={this.handleLeakageList}
                  onKeyUp={this.handleLeakageList}
                >
                  <Icon name="shield" style={{ color: '#969696' }} />
                  {translate('card.menu.leakage')}
                </a>
              </li>
            ) : null
          }
          <li>
            {
              scanStatus === 2 && componentCountBroad.total > 0 ? (
                <a
                  onClick={this.setCompareItem}
                  onKeyUp={this.setCompareItem}
                >
                  <img src={compareBtn} alt="" />
                  {translate('card.menu.compare')}
                </a>
              ) : (
                <a
                  style={{
                    cursor: 'default',
                    opacity: '.45',
                    color: '#dddddd',
                  }}
                >
                  <img src={compareBtn} alt="" />
                  {translate('card.menu.compare')}
                </a>
              )
            }
          </li>
          <li>
            {this.renderMoveMenu()}
          </li>
          <li>
            {
              scanStatus !== 2 || (componentCountBroad.total === 0 && !componentCountBroad.total) ? (
                <a
                  style={{
                    cursor: 'default',
                    opacity: '.45',
                    color: '#dddddd',
                  }}
                >
                  <Icon name="bookmark outline" style={iconStyle} />
                  {translate('card.menu.bookmark')}
                </a>
              ) : (
                <a
                  onClick={(e) => { return this.handleCardBookmarkChange(e, uid); }}
                  onKeyUp={(e) => { return this.handleCardBookmarkChange(e, uid); }}
                >
                  {
                    isBookmark ? (
                      <Icon name="bookmark" style={iconStyle} />
                    ) : (
                      <Icon name="bookmark outline" style={iconStyle} />
                    )
                  }
                  {translate('card.menu.bookmark')}
                </a>
              )
            }
          </li>
          <li>{this.renderJiraIssueEle(jiraIssue)}</li>
          {
            state.user.use_crypto && scanStatus === 2 ? (
              <li>
                <a
                  onClick={this.handleCBOM}
                  onKeyUp={this.handleCBOM}
                >
                  <Icon name="download" style={iconStyle} />
                  CBOM
                </a>
              </li>
            ) : null
          }
          <li>
            {
              scanStatus === 2 ? (
                <a
                  className="sbom"
                  onClick={this.handleSlideToggle}
                  onKeyUp={this.handleSlideToggle}
                >
                  <img src={exportIcon} alt="" />
                  SBOM
                </a>
              ) : (
                <a
                  className="sbom"
                  style={{
                    cursor: 'default',
                    opacity: '.45',
                    color: '#dddddd',
                  }}
                >
                  <img src={exportIcon} alt="" />
                  SBOM
                </a>
              )
            }
            <ul
              className={cx(
                'sub_menu',
                {
                  active: isShowSbom,
                },
              )}
            >
              <li style={{ padding: '0 0 0 20px' }}>
                <a
                  onClick={this.handleExport}
                  onKeyUp={this.handleExport}
                >
                  <Icon name="download" style={iconStyle} />
                  {translate('card.menu.clarity')}
                </a>
              </li>
              {scanStatus === 2 ? (
                <>
                  <li style={{ padding: '0 0 0 20px' }}>
                    <a
                      onClick={this.handleSpdx}
                      onKeyUp={this.handleSpdx}
                    >
                      <Icon name="download" style={iconStyle} />
                      {translate('card.menu.spdx')}
                    </a>
                  </li>
                  <li style={{ padding: '0 0 0 20px' }}>
                    <a
                      onClick={this.handleCycloneDx}
                      onKeyUp={this.handleCycloneDx}
                    >
                      <Icon name="download" style={iconStyle} />
                      CycloneDX
                    </a>
                  </li>
                  <li style={{ padding: '0 0 0 20px' }}>
                    <a
                      onClick={this.handleVexBom}
                      onKeyUp={this.handleVexBom}
                    >
                      <Icon name="download" style={iconStyle} />
                      VEX
                    </a>
                  </li>
                  <li style={{ padding: '0 0 0 20px' }}>
                    <a
                      onClick={this.handleNIASbom}
                      onKeyUp={this.handleNIASbom}
                    >
                      <Icon name="download" style={iconStyle} />
                      NIS
                    </a>
                  </li>
                </>
              ) : (
                <>
                  <li style={{ padding: '0 0 0 20px' }}>
                    <a
                      style={{
                        cursor: 'default',
                        opacity: '.45',
                        color: '#dddddd',
                      }}
                    >
                      <Icon name="download" style={iconStyle} />
                      {translate('card.menu.spdx')}
                    </a>
                  </li>
                  <li style={{ padding: '0 0 0 20px' }}>
                    <a
                      style={{
                        cursor: 'default',
                        opacity: '.45',
                        color: '#dddddd',
                      }}
                    >
                      <Icon name="download" style={iconStyle} />
                      CycloneDX
                    </a>
                  </li>
                  <li style={{ padding: '0 0 0 20px' }}>
                    <a
                      style={{
                        cursor: 'default',
                        opacity: '.45',
                        color: '#dddddd',
                      }}
                    >
                      <Icon name="download" style={iconStyle} />
                      VEX
                    </a>
                  </li>
                  <li style={{ padding: '0 0 0 20px' }}>
                    <a
                      style={{
                        cursor: 'default',
                        opacity: '.45',
                        color: '#dddddd',
                      }}
                    >
                      <Icon name="download" style={iconStyle} />
                      NIS
                    </a>
                  </li>
                </>
              )}
            </ul>
          </li>
          {
            (scanStatus === 2 || scanStatus === 3)
            && (
              <li>
                {
                  scanStatus === 3
                && (
                  <a
                    onClick={this.rescanReport}
                    onKeyUp={this.rescanReport}
                  >
                    <Icon name="refresh" style={iconStyle} />
                    {translate('modal.new_scan.title.rescan')}
                  </a>
                )
                }
                {
                  scanStatus === 2
                && (
                  <a
                    onClick={this.refreshSecurityReport}
                    onKeyUp={this.refreshSecurityReport}
                  >
                    <Icon name="refresh" style={iconStyle} />
                    {translate('modal.new_scan.title.refresh_security')}
                  </a>
                )
                }
              </li>
            )
          }
          {
            (scanStatus === 2 && !isScanning)
            && (
              <li>
                <a
                  onClick={this.handleAddScanResults}
                  onKeyUp={this.handleAddScanResults}
                >
                  <Icon name="add" style={iconStyle} />
                  {translate('card.menu.add_scan_result')}
                </a>
              </li>
            )
          }
          <li>
            {hasPermission ? (
              <a
                onClick={this.handleDelete}
                onKeyUp={this.handleDelete}
              >
                <img src={deleteIcon} alt="" />
                {translate('card.menu.delete')}
              </a>
            ) : (
              <a
                style={{
                  cursor: 'default',
                  opacity: '.45',
                  color: '#dddddd',
                }}
              >
                <img src={deleteIcon} alt="" />
                {translate('card.menu.delete')}
              </a>
            )}
          </li>
        </ul>
        <DeleteModal
          isOpen={isOpen}
          closeModal={this.closeModal}
          rowData={rowData}
          deletedCallback={this.deletedCallback}
          translate={translate}
        />
        <ExportModal
          isOpenMED={modalExportIsOpen}
          onClose={this.closeModal}
          handleModal={this.downloadReport}
          isDownloading={isDownloadingReport}
          birdView
          rowData={rowData}
          translate={translate}
        />
        <MoveFileModal
          isOpenMFM={isOpenMFM}
          closeModal={this.closeModal}
          rowData={rowData}
          isMovingFile={isMovingFile}
          setFileMove={this.setFileMove}
          translate={translate}
        />
        <SecurityRiskUpdatedModal
          isOpenMSU={isOpenMSU}
          reportId={rowData.uid}
          closeModal={this.closeModal}
          translate={translate}
        />
        <SPDXDocumentGenerator
          isOpenMCX={isOpenMCX}
          reportId={rowData.uid}
          uploadedFileName={rowData.name}
          closeModal={this.closeModal}
          translate={translate}
        />
        <CycloneDXDocumentGenerator
          isOpenMCD={isOpenMCD}
          reportId={rowData.uid}
          closeModal={this.closeModal}
          translate={translate}
        />
        <VexGenerator
          isOpenMVX={isOpenMVX}
          reportId={rowData.uid}
          closeModal={this.closeModal}
          translate={translate}
        />
        <CBOMGenerator
          isOpenMCB={isOpenMCB}
          reportId={rowData.uid}
          fileName={rowData.name}
          closeModal={this.closeModal}
          translate={translate}
        />
        <CreateUserIssueModal
          isOpenMCI={isOpenMCI}
          idReport={uid}
          closeModal={this.closeModal}
          completeCallback={this.handleIssueCallback}
          translate={translate}
          location={location}
        />
        <NISModal
          isOpenMNA={isOpenMNA}
          reportId={uid}
          translate={translate}
          closeModal={this.closeModal}
        />
        <ScanResultModal
          isOpenMSR={isOpenMSR}
          reportId={uid}
          translate={translate}
          handleSaveCallback={this.handleSaveCallback}
          closeModal={this.closeModal}
        />
        <ScanInfoModal
          isOpenMSI={isOpenMSI}
          reportId={scanInfoUid}
          closeModal={this.closeModal}
          translate={translate}
        />
        <LeakageListModal
          isOpenMLK={isOpenMLK}
          uploadedFileId={selectedUid}
          fileName={selectedName}
          closeModal={this.closeModal}
          translate={translate}
        />
        <Modal open={isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                {
                  toExport === 's3' ? (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      {this.modalHeader}
                      {this.modalSubBody}
                    </Modal.Description>
                  ) : (
                    <Modal.Description>
                      <Header>
                        {this.modalBody}
                      </Header>
                      <p className="modal_list">{this.modalHeader}</p>
                    </Modal.Description>
                  )
                }

                <div className="button_wrap">
                  <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default MoreOptionsMenu;
